export const COMMON_CONSTANTS = {
  authTokenKey: 'authToken',
  baseURL: `${process.env.REACT_APP_HOST_URL ?? ''}`,
  dateFormat: 'dd.MM.yy',
}
